// extracted by mini-css-extract-plugin
export default {"loginPage":"LoginPage_loginPage__k1HRn","signInContainer":"LoginPage_signInContainer__NyJPj","checkBoxContainer":"LoginPage_checkBoxContainer__0Mx+O"};